import { defineMessages } from "../../i18n";

export const languageSettingsMessages = defineMessages({
  ko: {
    eyebrow: "LANGUAGE & REGION",
    title: "앱 언어",
    description:
      "메뉴와 안내 문구의 언어를 바꿔요. 종목명·티커와 실제 통화는 그대로 유지됩니다.",
    regionLabel: "앱 언어 선택",
    selected: ({ language }: { readonly language: string }) =>
      `${language} 선택됨`,
    changeTo: ({ language }: { readonly language: string }) =>
      `${language}(으)로 변경`,
    currentLanguage: "현재 언어",
    persistenceWarning:
      "지금 화면에는 적용됐지만 이 브라우저에 언어 선택을 저장하지 못했어요. 다음 실행에서 다시 선택해 주세요.",
  },
  en: {
    eyebrow: "LANGUAGE & REGION",
    title: "App language",
    description:
      "Change menus and guidance. Company names, tickers, and real currencies stay untouched.",
    regionLabel: "Choose app language",
    selected: ({ language }: { readonly language: string }) =>
      `${language} selected`,
    changeTo: ({ language }: { readonly language: string }) =>
      `Switch to ${language}`,
    currentLanguage: "Current language",
    persistenceWarning:
      "The language changed for this session, but this browser could not save your choice. You may need to choose it again next time.",
  },
});
